/**
 * @file env.ts
 * @description Déclaration de l'URL de base utilisée pour les requêtes API dans l'application.
 * L'URL change selon l'environnement (production ou développement).
 */
export const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export function isStagOrDev() {
  return (
    !process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL === 'https://api2.comptanova.fr'
  );
}
